import { yupResolver } from "@hookform/resolvers/yup";
import { useMediaQuery } from "@material-ui/core";
import { Box, Stack, TextField, Theme, useTheme } from "@mui/material";
import { useRequest } from "ahooks";
import Button from "components/Overrides/Button/Button";
import { ROUTES } from "helpers/routes";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { serviceCheckIn } from "services/api/visitor";
import urlcat from "urlcat";
import * as yup from "yup";

const schema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("First name is required"),
  email: yup.string().required("Email is required").email("Email is invalid"),
  position: yup.string().required("Position is required"),
  companyName: yup.string().required("Company name is required"),
});

const FormCheckInNewVisitor = () => {
  const theme: Theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const params = Object.fromEntries(queryParams.entries());

  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm<Visitor>({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: { ...params },
  });
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { loading, run: createVisitor } = useRequest(serviceCheckIn, {
    manual: true,
    onSuccess: ({ success = false, data = undefined }) => {
      if (success) {
        navigate(urlcat(ROUTES.SELECT_TOPIC, { ...data }));
      }
    },
    onError: (error) => {
      console.log({ error });
    },
    onFinally: (_, data, error) => {},
  });

  const onSubmit = async (data: Visitor) => {
    createVisitor(data);
  };

  const onError = (errors: any) => {
    console.log(errors);
  };

  return (
    <Stack spacing={4} alignItems="center">
      <Stack gap={2} direction="row" flexWrap="wrap" style={{ width: "100%" }}>
        <Box style={{ flex: isMobile ? "1 0 100%" : "1 0 46%" }}>
          <Controller
            name="firstName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="First Name"
                margin="normal"
                error={!!errors.firstName}
                helperText={errors.firstName?.message as string}
              />
            )}
          />
        </Box>
        <Box style={{ flex: isMobile ? "1 0 100%" : "1 0 46%" }}>
          <Controller
            name="lastName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Last Name"
                margin="normal"
                error={!!errors.lastName}
                helperText={errors.lastName?.message as string}
              />
            )}
          />
        </Box>
        <Box style={{ flex: isMobile ? "1 0 100%" : "1 0 46%" }}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                type="email"
                label="Your work email"
                margin="normal"
                error={!!errors.email}
                helperText={errors.email?.message as string}
              />
            )}
          />
        </Box>
        <Box style={{ flex: isMobile ? "1 0 100%" : "1 0 46%" }}>
          <Controller
            name="position"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Position"
                margin="normal"
                error={!!errors.position}
                helperText={errors.position?.message as string}
              />
            )}
          />
        </Box>
        <Box style={{ flex: "1 0 100%" }}>
          <Controller
            name="companyName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Company Name"
                margin="normal"
                error={!!errors.companyName}
                helperText={errors.companyName?.message as string}
              />
            )}
          />
        </Box>
      </Stack>

      <Box>
        <Button
          variant="contained"
          disabled={!isValid || !isDirty || loading}
          onClick={handleSubmit(onSubmit, onError)}
          style={{ paddingInline: theme.spacing(8) }}
        >
          Done
        </Button>
      </Box>
    </Stack>
  );
};

export default FormCheckInNewVisitor;
